<template>
  <Card title="Accounting Settings" lg-title>
    <template #body>
      <div class="d-flex flex-column">
        <!-- Accounting Categories -->
        <div v-if="showAccountingCategories">
          <div class="d-flex flex-column">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <span><b>Accounting Categories</b></span>
              <span
                class="link"
                data-cy="add-accounting-category"
                @click="setCurrent(null, 'currentCategory', 'categoryModal')"
              >
                <i class="fa fa-plus mr-1"></i>
                Add
              </span>
            </div>
            <div class="d-flex">
              <ul>
                <li
                  v-for="category in accountingCategories[0]"
                  :key="category.id"
                >
                  <span
                    class="link break-long-word"
                    @click="
                      setCurrent(category, 'currentCategory', 'categoryModal')
                    "
                    >{{ category.name }}</span
                  >
                </li>
              </ul>
              <ul>
                <li
                  v-for="category in accountingCategories[1]"
                  :key="category.id"
                >
                  <span
                    class="link break-long-word"
                    @click="
                      setCurrent(category, 'currentCategory', 'categoryModal')
                    "
                    >{{ category.name }}</span
                  >
                </li>
              </ul>
            </div>
          </div>
          <AccountingCategoryModal
            v-if="categoryModal"
            :accounting-category="currentCategory"
            @hide-modal="setCurrent(null, 'currentCategory', 'categoryModal')"
            @save-success="refreshData"
          />
          <div class="my-3 border-bottom"></div>
        </div>
        <!-- Accounting Classes -->
        <div v-if="showAccountingClasses" class="d-flex flex-column">
          <div class="d-flex align-items-center justify-content-between mb-1">
            <span><b>Accounting Classes</b></span>
            <span
              class="link"
              data-cy="add-accounting-class"
              @click="setCurrent(null, 'currentClass', 'classModal')"
            >
              <i class="fa fa-plus mr-1"></i>
              Add
            </span>
          </div>
          <div class="d-flex">
            <ul>
              <li v-for="aclass in accountingClasses[0]" :key="aclass.id">
                <ArchivedLabel hide-archived-text :disabled="!aclass.archived">
                  <span
                    class="link break-long-word"
                    @click="setCurrent(aclass, 'currentClass', 'classModal')"
                    >{{ aclass.name }}</span
                  >
                </ArchivedLabel>
              </li>
            </ul>
            <ul>
              <li v-for="aclass in accountingClasses[1]" :key="aclass.id">
                <ArchivedLabel hide-archived-text :disabled="!aclass.archived">
                  <span
                    class="link break-long-word"
                    @click="setCurrent(aclass, 'currentClass', 'classModal')"
                    >{{ aclass.name }}</span
                  >
                </ArchivedLabel>
              </li>
            </ul>
          </div>
        </div>
        <AccountingClassModal
          v-if="classModal"
          :accounting-class="currentClass"
          @hide-modal="setCurrent(null, 'currentClass', 'classModal')"
          @save-success="refreshData"
        />
      </div>
    </template>
  </Card>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { splitArray } from "@/lib/helpers.js";

import ArchivedLabel from "@/components/ArchivedLabel.vue";
import Card from "@/components/Card.vue";
import AccountingCategoryModal from "@/CompanySettings/AccountingCategoryModal.vue";
import AccountingClassModal from "@/CompanySettings/AccountingClassModal.vue";

export default {
  components: {
    ArchivedLabel,
    Card,
    AccountingCategoryModal,
    AccountingClassModal
  },
  data() {
    return {
      categoryModal: false,
      currentCategory: null,
      classModal: false,
      currentClass: null
    };
  },
  computed: {
    ...mapGetters(["showAccountingCategories", "showAccountingClasses"]),
    ...mapState({
      accountingCategories: function ({ accountingCategories }) {
        return splitArray(accountingCategories);
      },
      accountingClasses: ({ accountingClasses }) => {
        return splitArray(Object.values(accountingClasses));
      }
    })
  },
  mounted() {
    // Load initial data
    this.refreshData();
  },
  methods: {
    ...mapActions(["fetchAccountingCategories", "fetchAccountingClasses"]),
    refreshData() {
      // Reload data after changes
      this.fetchAccountingCategories();
      this.fetchAccountingClasses();
    },
    setCurrent(data, type, modal) {
      this[type] = data;
      this[modal] = !this[modal];
    }
  }
};
</script>

<style lang="scss" scoped>
ul {
  padding: 0 15px;
  flex: 1;
}
</style>
